import { ButtonProps } from '@chakra-ui/react';
import React from 'react';
import { Button } from '@/components/Button/Button';

export default function index(props: ButtonProps) {
  return <Button {...props} sx={{ color: 'alpha.500', ...props.sx }} />;
}
